import {
    GET_POSTAL_CODE,
    GET_POSTAL_CODE_FULFILLED,
    GET_POSTAL_CODE_REJECTED,
    GET_POSTAL_CODE_PENDING
  } from "../actions/types";
  
  const initialState = {
    data: [],
    loading: false,
    error: false,
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case GET_POSTAL_CODE_PENDING:
        return {
          ...state,
          loading: true,
          error: false,
        };
      case GET_POSTAL_CODE_FULFILLED:
        return {
          ...state,
          data: action.payload,
          loading: false,
          error: false,
        };
      case GET_POSTAL_CODE_REJECTED:
        return {
          ...state,
          data: [],
          loading: false,
          error: true,
        };
      case GET_POSTAL_CODE:
        return {
          ...state,
          data: [],
        };
      default:
        return state;
    }
  }
  